module.exports = "/dist/fonts/Suranna-Regular.0800ad6f.ttf";